import { render, staticRenderFns } from "./contact-list-creator.vue?vue&type=template&id=2a054c74"
import script from "./contact-list-creator.vue?vue&type=script&lang=js"
export * from "./contact-list-creator.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports